import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties'
import { motion } from 'framer-motion';
import './style.css'
import { ReactComponent as Partner1 } from 'assets/Home/partner/partner1.svg'
import { ReactComponent as Partner2 } from 'assets/Home/partner/partner2.svg'
import { ReactComponent as Partner3 } from 'assets/Home/partner/partner3.svg'
import { ReactComponent as Partner4 } from 'assets/Home/partner/partner4.svg'
// import { ReactComponent as Partner5 } from 'assets/Home/partner/partner6.svg'
import { ReactComponent as Partner6 } from 'assets/Home/partner/partner6.svg'
import { ReactComponent as Partner7 } from 'assets/Home/partner/partner7.svg'
import { ReactComponent as Partner8 } from 'assets/Home/partner/partner8.svg'
import { ReactComponent as Partner9 } from 'assets/Home/partner/partner9.svg'
// import { ReactComponent as Partner10 } from 'assets/Home/partner/partner6.svg'
import { ReactComponent as Partner11 } from 'assets/Home/partner/partner11.svg'
import { ReactComponent as Partner12 } from 'assets/Home/partner/partner12.svg'

const Fourth = ({ activeIndex }: any) => {

  const partner = [
    { logo: Partner1, gridArea: 'a', hover: '#E31717' },
    { logo: Partner2, gridArea: 'b', hover: '#1A2662' },
    { logo: Partner3, gridArea: 'c', hover: '#FFA851' },
    { logo: Partner4, gridArea: 'd', hover: '#7E31BA' },
    // { logo: Partner5, gridArea: 'e', hover: '#FFA851' },
    { logo: Partner6, gridArea: 'e', hover: '#00D1FF' },
    { logo: Partner7, gridArea: 'f', hover: '#3937A6' },
    { logo: Partner8, gridArea: 'g', hover: '#FFD600' },
    { logo: Partner9, gridArea: 'h', hover: '#1C77FF' },
    // { logo: Partner10, gridArea: 'j', hover: '#FFA851' },
    { logo: Partner11, gridArea: 'i', hover: '#39CE51' },
    { logo: Partner12, gridArea: 'j', hover: '#721CFF' },
  ]
  return (
    <div className="flex justify-center items-center bg-black w-full h-screen overflow-hidden">
      <div className='container'>
        <div className="gap-2 grid mainContainer">
          {
            activeIndex === 3 &&
            partner.map((item, idx) => (
              <motion.div
                key={idx}
                className={`flex justify-center items-center py-4 bg-[#000] transition-all duration-200 ease-in-out`}
                style={{ gridArea: item.gridArea }}
                transition={{ delay: 0.1 * idx }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLElement).style.backgroundColor = item.hover;
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLElement).style.backgroundColor = "black";
                }}
                initial={START_ANIMATION_PROPERTY}
                whileInView={END_ANIMATION_PROPERTY}
                viewport={VIEWPORT_PROPERTY} >
                <item.logo />
              </motion.div>
            ))
          }
        </div>
      </div>
    </div>
  )
}

export default Fourth
